import { render, staticRenderFns } from "./generic-info-avatar.vue?vue&type=template&id=96515de0&"
import script from "./generic-info-avatar.vue?vue&type=script&lang=js&"
export * from "./generic-info-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports